// spare parts consts
export const SPARE_PART_STATUS_LOST = 'lost';
export const SPARE_PART_LOSS_REASON_REPAIRMAN_RECEPTION = 'repairman_reception';
export const SPARE_PART_RECEIVED_STATUS = 'received_tech';

// packages consts
export const PACKAGE_STATUS_SENT = 'sent';
export const PACKAGE_STATUS_RECEIVED = 'received';
